var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import _ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { ArrowLink } from '../../elements/ArrowLink';
import { List, ListItem } from '../../elements/List';
import { MENU_ACTION_TYPE, useMenu } from '../../providers/menu';
import { Row } from '../../elements/layout/Row';
import { Column } from '../../elements/layout/Column';
import { HEADING_SIZE, Heading } from '../../elements/Heading';
import { Link } from '../../elements/Link';
import { FONT_SIZE, FONT_WEIGHT } from '../../../theme/typography';
import { COLOR } from '../../../theme/colors';
import { importedDefaultComponentShim } from '../../../utils/misc';
const ChevronRightIcon = importedDefaultComponentShim(_ChevronRightIcon);
export const NavMenu = (props) => {
    const { sx } = props, rest = __rest(props, ["sx"]);
    const { isOpen, activePath, getMenuItem, getMenuItemProps, getMenuProps } = useMenu();
    if (!isOpen) {
        return null;
    }
    const topLevelMenuId = activePath[0];
    const activeTopLevelMenu = getMenuItem([topLevelMenuId]);
    if (!activeTopLevelMenu ||
        !(activeTopLevelMenu.action.type === MENU_ACTION_TYPE.SUBMENU)) {
        return null;
    }
    const submenu = activeTopLevelMenu.action.submenu;
    return (_jsxs(Row, Object.assign({}, rest, { sx: Object.assign({ justifyContent: 'center', p: 3, border: 'solid 1px', borderColor: COLOR.EXTRA_LIGHT_GRAY, bg: COLOR.WHITE, borderRadius: '4px', margin: '0px 10px 0px 10px' }, sx) }, { children: [_jsx(Column, { sx: { flexGrow: 1 } }), submenu.items.map((submenuItem, i) => {
                if (!(submenuItem.action.type === MENU_ACTION_TYPE.SUBMENU)) {
                    return null;
                }
                const leafMenuItems = submenuItem.action.submenu.items;
                const submenuPath = [topLevelMenuId, submenuItem.id];
                const link = '//' + document.location.host + topLevelMenuId;
                const category = topLevelMenuId.charAt(1).toUpperCase() + topLevelMenuId.slice(2);
                return (_jsxs(Column, Object.assign({ sx: {
                        flexBasis: '300px',
                        py: 2,
                        px: 4,
                        flexShrink: 0,
                        flexGrow: 0,
                    } }, { children: [_jsx(Heading, Object.assign({ standalone: true, size: HEADING_SIZE.SM, underline: true }, getMenuItemProps(submenuPath), { children: submenuItem.label })), _jsx(List, Object.assign({}, getMenuProps(submenuPath), { icon: ChevronRightIcon, iconSize: FONT_SIZE.MS }, { children: leafMenuItems.map((leafMenuItem, i) => {
                                var _a;
                                const leafMenuPath = submenuPath.concat(leafMenuItem.id);
                                return (_jsx(ListItem, Object.assign({ index: i, sx: { mt: 2 } }, getMenuItemProps(leafMenuPath), { children: _jsx(Link, Object.assign({ to: (_a = leafMenuItem === null || leafMenuItem === void 0 ? void 0 : leafMenuItem.action) === null || _a === void 0 ? void 0 : _a.to, sx: {
                                            fontWeight: FONT_WEIGHT.BOLD,
                                        }, tabIndex: -1 }, { children: leafMenuItem.label })) }), leafMenuItem.id));
                            }) })), i < 1 && (link.includes('esearch') || link.includes('ervices')) ? (_jsxs(ArrowLink, Object.assign({ to: link, sx: { margin: '20px 10px 10px 10px' } }, { children: ["View More ", category] }))) : null] }), submenuItem.id));
            }), _jsx(Column, { sx: { flexGrow: 1 } })] })));
};
